import React from "react";
import {
  Badge,
  Header as DSHeader,
  FilterCells,
  Paragraph,
  Icon,
  useColorTokens
} from "@tvg/design-system";
import { FilterOptionProps } from "@tvg/design-system/src/components/filterCells/types";
import { Props } from "./types";
import { HandicappingTab } from "../../../../types";
import { HEADER_QA_LABEL } from "../contants";
import {
  BadgeContainer,
  Container,
  FiltersContainer,
  ContainerParagraph
} from "./styled-components";

const buildOptions = (tabs: HandicappingTab[]): FilterOptionProps[] =>
  tabs.map(({ icon, name, value }) => ({
    value,
    label: name,
    iconName: icon,
    iconSide: "left"
  }));

const Header = ({
  title,
  tabs,
  activeDataSource,
  onChange,
  talentPicksCount = 0,
  isResulted,
  isRaceOff,
  isMobile = false
}: Props) => {
  const colorTokens = useColorTokens();
  const filterOptions = buildOptions(tabs);
  const additionalDSHeaderStyle = isMobile
    ? {
        fontWeight: "bold",
        fontSize: "m",
        lineHeight: "20px"
      }
    : {
        width: "100%",
        fontWeight: "medium",
        fontSize: "l",
        lineHeight: "35px"
      };

  return (
    <Container numberOfTabs={tabs.length}>
      <DSHeader
        tag="h2"
        qaLabel={HEADER_QA_LABEL.TITLE}
        {...additionalDSHeaderStyle}
      >
        {title}
      </DSHeader>
      {tabs.length > 0 &&
        (talentPicksCount > 0 && !isResulted && !isRaceOff ? (
          <FiltersContainer>
            <BadgeContainer>
              <Badge.Counter
                variant="secondary"
                counter={talentPicksCount}
                qaLabel={HEADER_QA_LABEL.BADGE}
              />
            </BadgeContainer>
            <FilterCells
              qaLabel={HEADER_QA_LABEL.FILTERS}
              filterOptions={filterOptions}
              activeValue={activeDataSource}
              size="m"
              onChange={onChange}
              isStretch={isMobile}
            />
          </FiltersContainer>
        ) : (
          ((filterOptions.length > 1 || !isMobile) && (
            <FilterCells
              qaLabel={HEADER_QA_LABEL.FILTERS}
              filterOptions={filterOptions}
              activeValue={activeDataSource}
              size="m"
              onChange={onChange}
            />
          )) ||
          (filterOptions.length === 1 && isMobile && (
            <ContainerParagraph>
              <Paragraph
                qaLabel="handicapping-filter-option-text"
                fontWeight={400}
                fontFamily="condensedRegular"
                fontSize="xs"
                color={colorTokens.content.subtle}
                textTransform="uppercase"
              >
                Data supplied by
              </Paragraph>
              {filterOptions[0]?.iconName && (
                <Icon
                  name={filterOptions[0]?.iconName}
                  lineColor={colorTokens.content.default}
                  size="s"
                  marginLeft="8px"
                />
              )}
              <Paragraph
                qaLabel="handicapping-filter-option-text"
                fontFamily="medium"
                color={colorTokens.content.default}
                marginLeft="2px"
              >
                {filterOptions[0]?.label || ""}
              </Paragraph>
            </ContainerParagraph>
          ))
        ))}
    </Container>
  );
};

export default Header;
